import { EnvironmentType } from "./environment.types";

export const environment: EnvironmentType = {
    isProduction: false,
    version: '1.0.420',

    api: 'https://api-instance-[hostinglocation].officemaps.dev',
    authority: 'https://login.officemaps.dev',
    officemaps: 'https://[instancecode].officemaps.dev',
    base_uri: `${window.location.origin}`,
    client_id: 'officemapsteams'
};
